import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=b4170b80&scoped=true"
import script from "./AddProduct.vue?vue&type=script&lang=ts"
export * from "./AddProduct.vue?vue&type=script&lang=ts"
import style0 from "./AddProduct.vue?vue&type=style&index=0&id=b4170b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4170b80",
  null
  
)

export default component.exports